import { render, staticRenderFns } from "./indentFooter.vue?vue&type=template&id=336d65ea&scoped=true&"
import script from "./indentFooter.vue?vue&type=script&lang=js&"
export * from "./indentFooter.vue?vue&type=script&lang=js&"
import style0 from "./indentFooter.vue?vue&type=style&index=0&id=336d65ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "336d65ea",
  null
  
)

export default component.exports